exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._avatar{border-radius:50%;overflow:hidden;background:#fff}._avatar .inner-avatar{background-color:#fff;background-size:contain;background-position:50%;background-repeat:no-repeat;height:70%;width:70%;margin:15%}._avatar.xs{width:32px;height:32px}._avatar.sm{width:40px;height:40px}._avatar.md{width:50px;height:50px}._avatar.lg{width:64px;height:64px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/avatar/avatar.styl
// module id = 417
// module chunks = 0